import { IScalarResponse } from "../entities-generated/common/scalar-response";
import { ICreatePresentationRequest } from "../entities-generated/models/presentation/create-presentation-request";
import { IGetPresentationForEditingResponse } from "../entities-generated/models/presentation/get-presentation-for-editing-response";
import { INoteActivePresentationSectionRequest } from "../entities-generated/models/presentation/note-active-presentation-section-request";
import { IPresentationListing } from "../entities-generated/models/presentation/presentation-listing";
import { IPresentationModel } from "../entities-generated/models/presentation/presentation-model";
import { IStartPresentationRequest } from "../entities-generated/models/presentation/start-presentation-request";
import { IUpdatePresentationRequest } from "../entities-generated/models/presentation/update-presentation-request";
import { ApiClient } from "./api-client";

class PresentationApiClientClass {
  public createPresentation(request: ICreatePresentationRequest) {
    return ApiClient.post<IScalarResponse<string>>('presentations', request);
  }

  public deletePresentation(presentationId: string) {
    return ApiClient.del<void>(`presentations/${presentationId}`);
  }

  public getAccountPresentationList() {
    return ApiClient.get<IPresentationListing[]>('presentations');
  }

  public getPresentation(presentationId: string) {
    return ApiClient.get<IPresentationModel>(`presentations/${presentationId}`);
  }

  public noteActivePresentationSection(presentationId: string, request: INoteActivePresentationSectionRequest) {
    return ApiClient.patch<void>(`presentations/${presentationId}/section`, request);
  }

  public startPresentation(presentationId: string, request: IStartPresentationRequest) {
    return ApiClient.patch<IPresentationModel>(`presentations/${presentationId}/start`, request);
  }

  public stopPresentation(presentationId: string) {
    return ApiClient.patch<void>(`presentations/${presentationId}/stop`, {});
  }

  public updatePresentation(request: IUpdatePresentationRequest) {
    return ApiClient.patch<void>('presentations', request);
  }

  public getPresentationForEditing(presentationId: string) {
    return ApiClient.get<IGetPresentationForEditingResponse>(`presentations/editable/${presentationId}`);
  }

  public getSearchableAccountPresentationTitles() {
    return ApiClient.get<string[]>('presentations/titles');
  }
}

export const PresentationApiClient = new PresentationApiClientClass();